/**
 * Escape a string for safe insertion into HTML text or attribute contexts.
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * Allow only https: URLs for use in img/src attributes; otherwise return empty string.
 */
export function sanitizeHttpsUrl(value: unknown): string {
  if (value === null || value === undefined) return "";
  const url = String(value).trim();
  if (!url.toLowerCase().startsWith("https://")) return "";
  return escapeHtml(url);
}
